import api from './api';

export interface NotaCreditoVentaDetalle {
    nroIdformulario: number;
    nroItem: number;
    codigoArticulo?: string;
    descripcionArticulo?: string;
    cantidad?: number;
    precioUnitario?: number;
    descuento?: number;
    porcDesc?: number;
    subtotal?: number;
    notas?: string;
    um?: string;
    codigoMoneda?: number;
    cotizacion?: number;
}

export interface NotaCreditoVenta {
    nroFormulario: number;
    nroTipoFormulario: string;
    tipoCliente: string;
    fechaEmision: Date | string;
    horaEmision?: Date | string;
    nroCliente: number;
    nombre: string;
    nroVendedor?: number;
    nroLista?: string;
    codigoMoneda: string | number;
    importeTotal: number;
    asentado?: string;
    descripcion?: string;
    usuario?: string;
    detalles?: NotaCreditoVentaDetalle[];
    porcDesc?: number | null;
    porcDesc2?: number | null;
    porcDesc3?: number | null;
    facturado?: string;
    nroFormularioFactura?: number;
    integrar?: number;
    estado?: string;
    letra?: string;
    nroSuc?: number;
    nroComprobante?: number;
    cuit?: string;
    caeNro?: string;
    caeVencimiento?: string | null;
    /** Asiento de libro diario vinculado al comprobante, si existe. */
    nroAsiento?: number | null;
}

export interface NotaCreditoVentaSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    fechaDesde?: Date;
    fechaHasta?: Date;
    nroCliente?: string;
    nroVendedor?: string;
    asentado?: string;
    estado?: string;
}

export interface NotaCreditoVentaPagedResult {
    items: NotaCreditoVenta[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

/** Item para crear una Nota de Crédito (POST api/NotasCreditoVenta) */
export interface NotaCreditoItemCreateDto {
    codigoArticulo: string;
    descripcion?: string;
    cantidad: number;
    precioUnitario: number;
    um?: string;
    codigoMoneda?: number;
    cotizacion?: number;
    notas?: string;
}

/** Formulario encabezado para crear una Nota de Crédito */
export interface NotaCreditoFormularioCreateDto {
    idCompania: string;
    descripcion?: string;
    nroSuc?: number;
    fechaEmision?: string;
    fechaVencim?: string;
    nroCliente: number;
    nombre?: string;
    nroLista?: string;
    formaDePago?: string;
    nroUbicacionOrigen?: number;
    ordenDeCompra?: string;
    codigoDireccion?: string;
    codigoDireccionEnvio?: string;
    formaEntrega?: string;
    nroFormularioFactura?: number;
    /** Si se informa y es > 0, se usa en el comprobante; si no, el backend toma el vendedor del cliente. */
    nroVendedor?: number;
    /** CUIT o documento del receptor en el comprobante. */
    cuit?: string;
    /** Condición IVA del receptor (I, M, C, …). */
    tipoIva?: string;
}

/** Payload para POST api/NotasCreditoVenta */
export interface NotaCreditoCreateDto {
    formulario: NotaCreditoFormularioCreateDto;
    items: NotaCreditoItemCreateDto[];
}

const notaCreditoVentaService = {
    getNotasCreditoVenta: async (params: NotaCreditoVentaSearchParams): Promise<NotaCreditoVentaPagedResult> => {
        const response = await api.get<NotaCreditoVentaPagedResult>('/api/NotasCreditoVenta', { params });
        return response.data;
    },

    getNotaCreditoVenta: async (id: number): Promise<NotaCreditoVenta> => {
        const response = await api.get<NotaCreditoVenta>(`/api/NotasCreditoVenta/${id}`);
        return response.data;
    },

    getNotaCreditoVentaPDF: async (id: number): Promise<Blob> => {
        const response = await api.get(`/api/NotasCreditoVenta/${id}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    },

    obtenerCaeArgentina: async (nroFormulario: number): Promise<NotaCreditoVenta> => {
        const response = await api.post<NotaCreditoVenta>(`/api/NotasCreditoVenta/${nroFormulario}/obtener-cae-argentina`);
        return response.data;
    },

    createNotaCredito: async (payload: NotaCreditoCreateDto): Promise<NotaCreditoVenta> => {
        const response = await api.post<NotaCreditoVenta>('/api/NotasCreditoVenta', payload);
        return response.data;
    },
};

export default notaCreditoVentaService;

